module.exports = __webpack_public_path__ + "img/6.914eb7a7.png";